import { Injectable } from "@angular/core";
import { Firestore, doc, updateDoc, setDoc, getDoc, collectionData, collection, query, where, getDocs, addDoc, DocumentData } from '@angular/fire/firestore';
import { BehaviorSubject, concat, from, Observable, Subject } from "rxjs";
import { FileUpload } from "src/app/model/file";
import { getStorage, ref, uploadBytesResumable, getDownloadURL, list, ListResult, listAll } from "firebase/storage";
import { HttpClient } from "@angular/common/http";
import { Lock } from "src/app/model/lock";
import { concatMap, switchMap, toArray } from "rxjs/operators";
import { Level } from "src/app/interfaces/academic-years";

@Injectable(
    {
        providedIn: 'root'
    }
)
export class ModuleService {


    private basePath = '/level1';

    public subject = new Subject();

    public uploadFinish = new Subject();

    public downloadError = new Subject();

    private year = new BehaviorSubject<String>(null);

    constructor(public firestore: Firestore, private http: HttpClient) { }


    /**
     * Download the course
     * 
     * @param collectionPath 
     * @param item
     * @param isWord
     */
    public downloadFile(collectionPath, item: any, isWord: boolean) {
        const storage = getStorage();
        let extension = isWord ? '.' + item.type : '.pptx';
        getDownloadURL(ref(storage, `${collectionPath}/${item.id}${extension}`))
            .then((url) => {
                this.http.get(url, {
                    responseType: 'blob'
                }).subscribe(blob => {
                    const a = document.createElement('a')
                    const objectUrl = URL.createObjectURL(blob)
                    a.href = objectUrl
                    a.download = `${item.id}${extension}`;
                    a.click();
                    URL.revokeObjectURL(objectUrl);
                })
            })
            .catch((error) => {
                this.downloadError.next("Impossible de télécharger le document, veuillez contacter l'administrateur du site.");
                this.downloadError.complete();
            });
    }

    async getYearInprogress(emailEtudiant: string): Promise<String> {
        const anneesRef = collection(this.firestore, `Etudiants/${emailEtudiant}/Annees`);
        const querySnapshot = query(anneesRef, where("status", "==", "en cours"));
        const shot = await getDocs(querySnapshot);
        let indexTrouve = "-1";
        shot.docs.forEach((doc, index) => {
            if (indexTrouve === "-1") {
                indexTrouve = doc.id;
            }
        });

        return new Promise<String>((resolve, reject) => {
            resolve(indexTrouve)
        });

    }

    /**
     * 
     * @returns 
     */
    public yearAsObsrvable() {

        return this.year.asObservable();
    }


    public next(value: String) {
        localStorage.setItem('year', value.toString());
        this.year.next(value);
    }

    public async addwork() {


        const docRef = doc(this.firestore, `/modules/level4`);
        const docSnap = await getDoc(docRef);
        const data = docSnap.data();

        let items = [];
        let list = [];
        for (let i in data) {
            let { id, index, unlocked }: { id: number, index: string, unlocked: boolean } = data[i];
            let item = { id, index, unlocked };
            item.unlocked = false;

            items.push(item);
        }

        // // Ajouter l'étudiant
        // // on ajoute un document
        const etudiantRef = collection(this.firestore, `modules/2024/level5`);
        for (const item of items) {

            await addDoc(etudiantRef, item);
        }

        // await setDoc(etudiantRef, student);

        // // Ajouter la collection d'année
        // const anneeRef = collection(this.firestore, `Etudiants/${student.email}/Annees`);

        // //on fixe le nom du document auquel on va ajouter des champs
        // const anneeDocRef = doc(anneeRef, year)        // for (const devoir of work) {
        ;
        // await setDoc(anneeDocRef, yearDoc);

        // // Ajouter le document de devoirs
        // const devoirsRef = collection(this.firestore, `Etudiants/${student.email}/Annees/${year}/Devoirs`);
        //     //génration des Id de chaque document en rajouter le devoir
        //     await addDoc(devoirsRef, devoir);
        //}
    }


    progressValueOfLevel(year: String, level: String): Observable<Level[]> {
        const levels = collection(this.firestore, `/modules/${year}/${level}`);
        return collectionData(levels, { idField: 'docId' }) as Observable<Level[]>;
    }



    progressValueOfLevels(year: String) {
        return concat(
            from(this.progressValueOfLevel(year, "level1")),
            from(this.progressValueOfLevel(year, "level2")),
            from(this.progressValueOfLevel(year, "level3")),
            from(this.progressValueOfLevel(year, "level4"))).pipe(
                toArray()
            );
    }

    /**
     * 
     * @param item 
     * @returns  @Promise<String>
     */
    public getUrlPdf(item): Promise<String> {
        return getDownloadURL(ref(getStorage(), `${item.level}/pdf/${item.id}.pdf`));
    }

    /**
     * 
     * @param fileUpload 
     * @param progress 
     */
    public pushFileToStorage(collectionPath, fileUploadPdf: FileUpload, fileUpload: FileUpload): void {
        const storage = getStorage();
        this.uploadPdf(collectionPath, fileUpload, fileUploadPdf);
    }


    private uploadPptx(collectionPath, fileUpload) {
        const storage = getStorage();
        let filePath = `${collectionPath}/${fileUpload.file.name}`;
        const storageRef = ref(storage, filePath);
        const uploadTask = uploadBytesResumable(storageRef, fileUpload.file);
        let progress: number = 0;
        uploadTask.on('state_changed',
            (snapshot) => {

                progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                this.subject.next(progress);
            },
            (error) => {
                console.log(error);
                this.uploadFinish.next(false);
            },
            () => {
                this.uploadFinish.next(true);

            }
        );
    }


    private uploadPdf(collectionPath, fileUpload, fileUploadpdf) {
        const storage = getStorage();
        let filePath = `${collectionPath}/pdf/${fileUploadpdf.file.name}`;
        const storageRef = ref(storage, filePath);
        const uploadTask = uploadBytesResumable(storageRef, fileUploadpdf.file);
        let progress: number = 0;
        uploadTask.on('state_changed',
            (snapshot) => {

                progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                this.subject.next(progress);
            },
            (error) => {
                console.log(error);
                this.uploadFinish.next(false);
            },
            () => {
                this.uploadPptx(collectionPath, fileUpload);
            }
        );
    }

    /**
     * 
     * @returns 
     */
    public async getFiles(path: string): Promise<ListResult> {
        const storage = getStorage();
        const listRef = ref(storage, path);
        return await list(listRef, { maxResults: 50 });
    }

    /**
     * 
     * @param path 
     * @returns 
     */
    public getModule(level: string): Observable<Level[]> {
        //let year = (new Date()).getFullYear()+"";
        let year = "2025";
        console.log(`/modules/${year}/${level}`)
        const levels = collection(this.firestore, `/modules/${year}/${level}`);
        return collectionData(levels, { idField: 'docId' }) as Observable<Level[]>;
    }

    /**
     * 
     * @param path 
     * @returns 
     */
    public async getLastControle(year: String) {
        const level1 = await getDocs(collection(this.firestore, `/class-works/${year}/level1`));
        const level2 = await getDocs(collection(this.firestore, `/class-works/${year}/level2`));
        const level3 = await getDocs(collection(this.firestore, `/class-works/${year}/level3`));
        const level4 = await getDocs(collection(this.firestore, `/class-works/${year}/level4`));
        let responseLastControle: { doc: DocumentData, receivedDoc: number, level: String }[] = [];

        if (!level1.empty) {
            let level: { doc: DocumentData, receivedDoc: number, level: String } = { doc: null, receivedDoc: 0, level: null };
            level.level = "1";
            level.doc = level1.docs[level1.docs.length - 1].data();
            const listRef = (await listAll(ref(getStorage(), `/evaluations/${year}/level1`))).items; // Créez une référence au répertoire souhaité
            level.receivedDoc = listRef.filter(x => x.name.replace(/\s+/g, ' ').trim().includes(level.doc.label.replace(/\s+/g, ' ').trim() + `.docx`)).map(x => x.name).length;
            responseLastControle.push(level);
        }
        if (!level2.empty) {
            let level: { doc: DocumentData, receivedDoc: number, level: String } = { doc: null, receivedDoc: 0, level: null };
            level.level = "2";
            level.doc = level2.docs[level2.docs.length - 1].data();
            const listRef = (await listAll(ref(getStorage(), `/evaluations/${year}/level2`))).items; // Créez une référence au répertoire souhaité
            level.receivedDoc = listRef.filter(x => x.name.replace(/\s+/g, ' ').trim().includes(level.doc.label.replace(/\s+/g, ' ').trim() + `.docx`)).map(x => x.name).length;
            responseLastControle.push(level);

        }
        if (!level3.empty) {
            let level: { doc: DocumentData, receivedDoc: number, level: String } = { doc: null, receivedDoc: 0, level: null };
            level.level = "3";
            level.doc = level3.docs[level3.docs.length - 1].data();
            const listRef = (await listAll(ref(getStorage(), `/evaluations/${year}/level3`))).items; // Créez une référence au répertoire souhaité
            level.receivedDoc = listRef.filter(x => x.name.replace(/\s+/g, ' ').trim().includes(level.doc.label.replace(/\s+/g, ' ').trim() + `.docx`)).map(x => x.name).length;
            responseLastControle.push(level);
        }
        if (!level4.empty) {
            let level: { doc: DocumentData, receivedDoc: number, level: String } = { doc: null, receivedDoc: 0, level: null };
            level.level = "4";
            level.doc = level4.docs[level4.docs.length - 1].data();
            const listRef = (await listAll(ref(getStorage(), `/evaluations/${year}/level4`))).items; // Créez une référence au répertoire souhaité
            level.receivedDoc = listRef.filter(x => x.name.replace(/\s+/g, ' ').trim().includes(level.doc.label.replace(/\s+/g, ' ').trim() + `.docx`)).map(x => x.name).length;
            responseLastControle.push(level);

        }
        console.log(responseLastControle)
        return new Promise<any>((resolve, reject) => {

            resolve(responseLastControle)
        });

    }


    public async tonton() {

        // const storage = getStorage(); // Obtenez une instance de Firebase Storage
        // const listRef = ref(storage, '/evaluations/2023/level1'); // Créez une référence au répertoire souhaité

        // listAll(listRef)
        //     .then((res) => {
        //         res.items.forEach((itemRef) => {
        //             // itemRef représente une référence à chaque fichier
        //             console.log(itemRef.name); // Affiche le nom de fichier
        //             // Vous pouvez également obtenir l'URL de téléchargement pour chaque fichier ici si nécessaire
        //         });
        //         // Si vous souhaitez également lister les sous-répertoires, vous pouvez itérer sur res.prefixes
        //     })
        //     .catch((error) => {
        //         console.log(error); // Gérez les erreurs ici
        //     });
    }

 
    public async modules() {

       /* const docRef = collection(this.firestore, "/modules/2024/level4")
        //doc(this.firestore, "/modules/2023/level4");
        let users = collectionData(docRef);
        // { idField: 'docId' }

        users.subscribe((x: any[]) => {

            console.log(x)

            console.log(x[0])


            for (let i of x) {

                i.unlocked = false;
                console.log(x[i]);
                const level1Ref = collection(this.firestore, '/modules/2025/level4');
                addDoc(level1Ref, i).then(x => {
   
                 console.log(x)
                }, error => console.log(error));
   

            }

           
        }
        );
        //const docSnap = await getDoc(docRef);


        // if (docSnap.exists()) {
        //     let data = docSnap.data()
        //     console.log(docSnap.data()[0]);

        //     for (let i in data) {

        //         data[i]["unlocked"] = false;

        //     }
        //     console.log(data);
        //     const level1Ref = collection(this.firestore, '/modules/2024/level1');
        //     addDoc(level1Ref, data).then(x => {

        //         console.log(x)
        //     }, error => console.log(error));
        // }

*/

    }

    /**
     * 
     * @param year The year
     * @param level module level
     * @returns  Observable<[Level[]]
     */
    public getLevelLessonFromYear(year: String, level: String): Observable<Level[]> {
        const levels = collection(this.firestore, `/modules/${year}/${level}`);
        return collectionData(levels) as Observable<Level[]>;
    }


    /**
   * 
   * @param year The year
   * @param level module level
   * @returns  Observable<[Level[]]
   */
    public updateLessonFromYear(year: String, level: String): Observable<[Level[]]> {
        const levels = collection(this.firestore, `/modules/${year}/${level}`);

        return collectionData(levels) as Observable<[Level[]]>;
    }

    /**
     * 
     * @param module 
     * @param level 
     */
    public async update(item: Level, year: String, level: String) {
        const documentRef = doc(this.firestore, `/modules/${localStorage.getItem("year")}/${level}/${item.docId}`);
        return setDoc(documentRef, item, { merge: true });
    }

    /**
     * 
     * @param year 
     * @param level 
     * @param documentId 
     * @returns 
     */
    public async updateStatusCourse(coursesToShare: { id: String, unlocked: Boolean, year: String, level: String }[]) {
        console.log(coursesToShare)
        coursesToShare.forEach(async item => {
            const documentRef = doc(this.firestore, `/modules/${item.year}/${item.level}/${item.id}`);
            const unlocked = item.unlocked;
            await updateDoc(documentRef, {
                unlocked
            });
        })
    }


    /**
     * 
     * @param elementsToShare 
     * @param level 
     * @returns 
     */
    public share(elementsToShare, level: string) {
        const noteDocRef = doc(this.firestore, `modules/${level}`);
        return updateDoc(noteDocRef, elementsToShare);
    }

    /**
     * 
     * @returns 
     */
    public getLocks() {
        return collectionData(collection(this.firestore, 'lock-module')) as Observable<Lock[]>;

    }

}